import isJwtTokenExpired from 'jwt-check-expiry';
import { URL } from 'url';

import { LoginClient } from './LoginClient';
import type { HealthbridgeToken, OAuth2Credentials } from './types';

export class HealthbridgeLoginClient extends LoginClient<
  OAuth2Credentials,
  HealthbridgeToken
> {
  private version = '1.0';
  private loginPath = `/authorization/${this.version}/token`;
  private loginURL: string;
  private authToken!: string;

  constructor(baseUrl: string, credentials: OAuth2Credentials) {
    super(baseUrl, credentials);
    this.loginURL = new URL(this.loginPath, baseUrl).href;
  }

  public getToken = async (): Promise<string> => {
    const isExpired = this.authToken ? isJwtTokenExpired(this.authToken) : true;

    if (!isExpired) {
      return this.authToken;
    }
    const loginResult = await this.login(this.loginURL);

    if (loginResult.error) {
      throw new Error(`Error logging in to Healthbridge: ${loginResult.error}`);
    }

    this.authToken = loginResult.access_token;

    return this.authToken;
  };
}
